import React from "react";
import { Badge } from "rizzui";
import { useNotification } from "./NotificationContext";

interface NotificationBadgeProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  className = "",
  size = "sm",
}) => {
  const { unreadCount, unreadCountApi } = useNotification();

  if (unreadCount === 0 && unreadCountApi === 0) {
    return null;
  }

  return (
    <Badge
      size={size}
      color="primary"
      className={`${className} ${unreadCount > 0 ? "animate-pulse" : ""}`}
    >
      {(unreadCountApi > 0 ? unreadCountApi : "") ||
        (unreadCount > 0 ? unreadCount : "")}
    </Badge>
  );
};

export default NotificationBadge;
